module.exports = __webpack_public_path__ + "img/potion2.76802d43.png";